import { render, staticRenderFns } from "./OverlayAlert.vue?vue&type=template&id=48e0f698&scoped=true"
import script from "./OverlayAlert.vue?vue&type=script&lang=js"
export * from "./OverlayAlert.vue?vue&type=script&lang=js"
import style0 from "./OverlayAlert.vue?vue&type=style&index=0&id=48e0f698&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e0f698",
  null
  
)

export default component.exports